<div class="flight-amenities-container">
  <h3 class="fare-includes" i18n="@@flightThefareyouhaveselectedincludes">
    The fare you have selected includes:
  </h3>
  <i class="custom_icon-season-tickets" aria-hidden="true"></i>
  @if (loadingRouteHappy) {
    <div class="loading" role="status" aria-live="polite">Loading...</div>
  } @else {
    <ul class="amenities-list">
      @if (
        routeHappyResults?.data?.amenitySummary &&
        routeHappyResults.data.amenitySummary.length > 0 &&
        routeHappyResults.data.amenitySummary[0].seat
      ) {
        <li class="amenity-details">
          <i class="custom_icon-seat" aria-hidden="true"></i>
          <span
            ><span class="visually-hidden">Seat: </span
            >{{ routeHappyResults?.data?.amenitySummary[0].seat.displayText }}</span
          >
        </li>
      }
      @if (
        routeHappyResults?.data?.boardingPriority &&
        routeHappyResults.data.boardingPriority.length > 0
      ) {
        <li class="amenity-details">
          <i class="custom_icon-boarding-priority" aria-hidden="true"></i>
          <span
            ><span class="visually-hidden">Boarding priority: </span
            >{{ routeHappyResults?.data.boardingPriority[0].description }}</span
          >
        </li>
      }
      @if (routeHappyResults?.data?.carryOnBag && routeHappyResults.data.carryOnBag.length > 0) {
        <li class="amenity-details">
          <i class="custom_icon-carry-on-bag" aria-hidden="true"></i>
          <span
            ><span class="visually-hidden">Carry-on bag: </span
            >{{ routeHappyResults?.data.carryOnBag[0].description }}</span
          >
        </li>
      }
      @if (routeHappyResults?.data?.checkedBag && routeHappyResults.data.checkedBag.length > 0) {
        <li class="amenity-details">
          <i class="custom_icon-luggage" aria-hidden="true"></i>
          <span
            ><span class="visually-hidden">Checked bag: </span
            >{{ routeHappyResults?.data.checkedBag[0].description }}</span
          >
        </li>
      }
    </ul>
  }
  @if (freeCarryOnBag || freeCheckedBag) {
    <ul class="amenities-list">
      @if (freeCarryOnBag) {
        <li class="amenity-details">
          <i class="custom_icon-carry-on-bag" aria-hidden="true"></i>
          <span><span class="visually-hidden">Carry-on bag: </span>{{ freeCarryOnBag.text }}</span>
        </li>
      }
      @if (freeCheckedBag) {
        <li class="amenity-details">
          <i class="custom_icon-luggage" aria-hidden="true"></i>
          <span><span class="visually-hidden">Checked bag: </span>{{ freeCheckedBag.text }}</span>
        </li>
      }
    </ul>
  }
</div>
